import { render } from "./UserListView.vue?vue&type=template&id=405a6534"
import script from "./UserListView.vue?vue&type=script&lang=js"
export * from "./UserListView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__